import React, { useState } from 'react'
import './Navbar.css'
import production from '../../images/production.png'
import portal from '../../images/portal.png'
import setting from '../../images/setting.png'
import { Link } from 'react-router-dom'
import ModelTracer from '../Pop/ModelTracer'
import tes from "../../images/test-manager.png"
const Configrationavbar = ({isActive}) => {
  const [openModelTracer, setOpenModelTracer] = useState(false);
  return (
    <>
    <div className={isActive ? "nav d-flex justify-content-between navactive": "nav d-flex justify-content-between"}>
       
    <div className="user-logo config-logo" >
           Configuration
        </div>
        <ul>
        <li> <Link to="/trs"><img src={production} alt="" /> Production Jigs</Link></li>
            <li> <Link to="/ProductSchedule"><img src={portal} alt="" /> Portals</Link> </li>
            <li> <Link to="/Configration"><img src={setting} alt="" />Stock Manager</Link> </li>
            <li> <Link to="/account"><img src={tes} alt="" />Account</Link> </li>
        </ul>
    </div>
    {openModelTracer && <ModelTracer closeModelTracer={setOpenModelTracer} />}
    </>
  )
}

export default Configrationavbar;